import { useNavigate } from "react-router-dom";
import Card from "../../components/card";
import React from 'react';
import styled from "styled-components";
import Breadcrumb, { BreadcrumbLink, BreadcrumbItem } from "../../components/ui/Breadcrumb";
import { ReactComponent as Plus } from "../../components/ui/styles/plus_icon.svg";
import { ReactComponent as HomeIcon } from "../../components/ui/styles/home.svg";
import Button from "../../components/ui/Button";


const Wrapper = styled.section`
    min-height: calc(100vh - 58px);
    margin-left: 250px;
    padding: 30px;
    box-sizing: border-box;
`;

const ProjectBlock = styled.div`
    .smallTitle {
        font-size: 16px !important;
        color: #666 !important;
        padding: 0;
        text-align: left;
        margin: 0 0 25px;
        font-weight: 700 !important;
    }
`;
const CardWrapper = styled.div`
    display: Grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    .smallTitle {
        font-size: 16px !important;
        color: #666 !important;
        padding: 0;
        text-align: left;
        margin: 0 0 25px;
        font-weight: 700 !important;
    }
    & > div {
        min-height: 250px;
    }
`;


export const WrapperHead = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
`;

export const WrapperHeadBtn = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
        background: #ed8154;
        border: 1px solid #ed8154;
        font-size: 14px !important;
        color: #fff;
        text-transform: capitalize;
        min-width: 225px;
        height: 42px;
        font-weight: 700;
        border-radius: 12px;
    }

    .iconButton {
        min-width: 42px;
        margin-right: 15px;

        svg {
            height: 18px;
            width: 18px;
        }
    }
`;

const PlatformSettings = () => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <Wrapper>
                <WrapperHead>
                    <Breadcrumb primary>
                        <BreadcrumbLink to={"/home"}><BreadcrumbItem children={<HomeIcon />} /></BreadcrumbLink>
                        <BreadcrumbLink to={"/company-settings/overview"}><BreadcrumbItem children={"Setting"} /></BreadcrumbLink>
                        <BreadcrumbLink to={"#"}><BreadcrumbItem children={"Platform Settings"} /></BreadcrumbLink>
                    </Breadcrumb>

                </WrapperHead>
                <ProjectBlock>
                    <h4 className="smallTitle">Platform Settings</h4>
                </ProjectBlock>
                <CardWrapper>
                    <Card
                        style={{ minHeight: "260px" }}
                        title="Domain"
                        buttonName="Edit"
                        onClick={() =>
                            navigate(`/company-settings/edit/domain`)
                        }

                    />
                    <Card
                        style={{ minHeight: "260px" }}
                        title="Mailer"
                        buttonName="Edit"
                        onClick={() =>
                            navigate(`/company-settings/edit/mailer`)
                        }

                    />
                </CardWrapper>
            </Wrapper>
        </React.Fragment>
    )
}

export default PlatformSettings;